import {gsap} from "gsap";
import {lenis} from "./main";

export const TransitionDefault = {
    name: 'transition-default',
    leave(data) {

        return new Promise(resolve => {

            gsap.to(data.current.container, {
                opacity: 0,
                onStart: () => {

                },
                onComplete: () => {
                    data.current.container.classList.add('d-none')
                    window.scrollTo(0, 0);  // Resetta lo scroll
                    lenis.scrollTo(0,{immediate:true})
                    resolve()
                }
            });

        })


    },
    enter(data) {
        return new Promise(resolve => {

            console.log('fa')

            gsap.set(data.next.container,{
                opacity: 0
            })


            document.querySelector('.header').classList.remove('hide');
            document.querySelector('.header').classList.remove('sticky');


            const videos = document.querySelectorAll('video[autoplay]');
            videos.forEach(video => {
                // reset tempo e fai partire
                video.currentTime = 0;
                video.play().catch(err => {
                    console.log('Video non avviato:', err);
                });
            });

            gsap.to(data.next.container, {
                opacity: 1,
                delay: .5,
                onComplete: () => {
                    resolve();
                }
            });

        })
    }
}
